import { createTypes, createAction } from "lib/action";

const LOAD_PLANT_ACCOUNT = createTypes("plant_account", "load");
const SHOW_PLANT_ACCOUNT = createTypes("plant_account", "show");
const CREATE_PLANT_ACCOUNT = createTypes("plant_account", "create");
const UPDATE_PLANT_ACCOUNT = createTypes("plant_account", "update");
const DELETE_PLANT_ACCOUNT = createTypes("plant_account", "delete");
const IMPORT_PLANT_ACCOUNT = createTypes("plant_account", "import");
const EXPORT_PLANT_ACCOUNT = createTypes("plant_account", "export");

const loadPlantAccount = {
  request: (params, token) => createAction(LOAD_PLANT_ACCOUNT.REQUEST, { params, token }),
  success: data => createAction(LOAD_PLANT_ACCOUNT.SUCCESS, { data }),
  failure: err => createAction(LOAD_PLANT_ACCOUNT.FAILURE, { err }),
};

const showPlantAccount = {
  request: (id, token) => createAction(SHOW_PLANT_ACCOUNT.REQUEST, { id, token }),
  success: data => createAction(SHOW_PLANT_ACCOUNT.SUCCESS, { data }),
  failure: err => createAction(SHOW_PLANT_ACCOUNT.FAILURE, { err }),
};

const createPlantAccount = {
  request: (params, token) => createAction(CREATE_PLANT_ACCOUNT.REQUEST, { params, token }),
  success: data => createAction(CREATE_PLANT_ACCOUNT.SUCCESS, { data }),
  failure: err => createAction(CREATE_PLANT_ACCOUNT.FAILURE, { err }),
};

const updatePlantAccount = {
  request: (params, id, token) => createAction(UPDATE_PLANT_ACCOUNT.REQUEST, { params, id, token }),
  success: data => createAction(UPDATE_PLANT_ACCOUNT.SUCCESS, { data }),
  failure: err => createAction(UPDATE_PLANT_ACCOUNT.FAILURE, { err }),
};

const deletePlantAccount = {
  request: (id, token) => createAction(DELETE_PLANT_ACCOUNT.REQUEST, { id, token }),
  success: id => createAction(DELETE_PLANT_ACCOUNT.SUCCESS, { id }),
  failure: err => createAction(DELETE_PLANT_ACCOUNT.FAILURE, { err }),
};

const importPlantAccount = {
  request: (file, company_id, token, mode) => createAction(IMPORT_PLANT_ACCOUNT.REQUEST, { file, company_id, token, mode }),
  success: data => createAction(IMPORT_PLANT_ACCOUNT.SUCCESS, { data }),
  failure: err => createAction(IMPORT_PLANT_ACCOUNT.FAILURE, { err }),
};

const exportPlantAccount = {
  request: (params, token) => createAction(EXPORT_PLANT_ACCOUNT.REQUEST, { params, token }),
  success: data => createAction(EXPORT_PLANT_ACCOUNT.SUCCESS, { data }),
  failure: err => createAction(EXPORT_PLANT_ACCOUNT.FAILURE, { err }),
};

export {
  loadPlantAccount,
  showPlantAccount,
  createPlantAccount,
  updatePlantAccount,
  deletePlantAccount,
  importPlantAccount,
  exportPlantAccount,
  LOAD_PLANT_ACCOUNT,
  SHOW_PLANT_ACCOUNT,
  CREATE_PLANT_ACCOUNT,
  UPDATE_PLANT_ACCOUNT,
  DELETE_PLANT_ACCOUNT,
  IMPORT_PLANT_ACCOUNT,
  EXPORT_PLANT_ACCOUNT
};
